import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServiceService } from '../../service.service';

interface Employee {
  employee_id: string;
  employee_name: string;
}

@Component({
  selector: 'app-department-master-edit',
  templateUrl: './department-master-edit.component.html',
  styleUrls: ['./department-master-edit.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class DepartmentMasterEditComponent implements OnInit {

  departmentId: string = '';
  departmentName: string = '';

  employees: Employee[] = [];
  selectedEmployeeId: string = '';

  isLoadingDept = false;
  isLoadingEmps = false;
  isSaving = false;

  loadError: string | null = null;
  successMessage: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ServiceService
  ) { }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      this.departmentId = params['department_id'] || '';
    });
    this.loadDepartment();
    this.loadEmployees();
  }

  loadDepartment(): void {
    this.isLoadingDept = true;
    this.apiService.ideasuggestiondepartmentDropdown().subscribe({
      next: (res: any) => {
        this.isLoadingDept = false;
        if (res && res.success && Array.isArray(res.data)) {
          const matchedDept = res.data.find((d: any) => d._id === this.departmentId);
          if (matchedDept) {
            this.departmentName = matchedDept.idea_department_name;
            this.selectedEmployeeId = matchedDept.idea_department_head_id || '';
          }
        }
      },
      error: () => {
        this.isLoadingDept = false;
        this.loadError = 'Failed to load department.';
      }
    });
  }

  loadEmployees(): void {
    this.isLoadingEmps = true;
    this.apiService.ViewAllEmployee().subscribe({
      next: (res: any) => {
        this.isLoadingEmps = false;
        if (res && (res.success || res.sucess) && Array.isArray(res.data)) {
          this.employees = res.data;
        }
      },
      error: () => {
        this.isLoadingEmps = false;
        this.loadError = 'Failed to load employees.';
      }
    });
  }

  onSave(): void {
    this.isSaving = true;
    this.loadError = null;
    this.successMessage = null;

    const selectedEmp = this.employees.find(e => e.employee_id === this.selectedEmployeeId);

    const body = {
      _id: this.departmentId,
      idea_department_head_id: this.selectedEmployeeId || null,
      idea_department_head_name: selectedEmp?.employee_name || null
    };

    this.apiService.assignIdeaDepartmentHead(body).subscribe({
      next: (res: any) => {
        this.isSaving = false;
        if (res && res.success) {
          this.successMessage = 'Updated successfully!';
          setTimeout(() => {
            this.router.navigate(['/admin/department-master-listing']);
          }, 1500);
        } else {
          this.loadError = 'Update failed. Please try again.';
        }
      },
      error: () => {
        this.isSaving = false;
        this.loadError = 'Failed to update. Please try again.';
      }
    });
  }

  onCancel(): void {
    this.router.navigate(['/admin/department-master-listing']);
  }

  clearEmployeeSelection(): void {
    this.selectedEmployeeId = '';
  }
}